import { GetContextResponse } from '@iwoca/lapi-client/edge';
import { mergeStates } from '../../../iwProvider/StoreHelper';
import { OPEN_BANKING_MODAL_DATA } from './LinkOpenBankingModal.actions';

const initialState = {
    stateKey: ''
};

// eslint-disable-next-line import/no-default-export
export default function (
    state = mergeStates(initialState),
    action: { type: string; site_context: GetContextResponse['data'] }
) {
    switch (action.type) {
        case OPEN_BANKING_MODAL_DATA:
            return mergeStates(state, {
                stateKey: action.site_context!.state_key
            });
        default:
            return state;
    }
}
